// extracted by mini-css-extract-plugin
export default {"project":"Project_project__CnGPs","projectName":"Project_projectName__XlM30","projectDescription":"Project_projectDescription__B+6l0"};